import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchCouponCollection,
  SearchCouponCollectionVariables
} from "./types/SearchCouponCollection";

export const searchCouponCollection = gql`
  ${pageInfoFragment}
  query SearchCouponCollection(
    $query: String!
    $category: [CouponCollectionCategoryEnum]
    $status: [CouponCollectionStatusEnum]
    $dealType: [CouponCollectionClassificationEnum]
    $sortBy: CouponCollectionSortingInput
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    search: couponCollections(
      filter: {
        search: $query
        status: $status
        categories: $category
        classification: $dealType
      }
      sortBy: $sortBy
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      edges {
        node {
          id
          title
          classification
          collectionType
          categories
          __typename
          status
          writeup
          startDate
          endDate
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchCouponCollection,
  SearchCouponCollectionVariables
>(searchCouponCollection);
